module.exports = __webpack_public_path__ + "img/ukraine.95722e6b.png";